import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

// Получаем корневой элемент
const rootElement = document.getElementById('root');

// Проверяем, что элемент существует
if (!rootElement) {
  throw new Error('Root element not found');
}

// Создаем корневой элемент React
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
